/********** Olympus reset CSS **********/
.isoNoteTextWrapper {
  margin: 0;
}



// WEBPACK FOOTER //
// ./src/layouts/App/styles/reset.css